// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2XFzU","title":"ClientReferral_title__2PO2o","itemText":"ClientReferral_itemText__1TH2p"};